module.exports = __webpack_public_path__ + "static/media/img01.f06bd24f.jpg";